import { capitalize } from './capitalize';
import { lowercase } from './lowercase';
import { uppercase } from './uppercase';
import { trim } from './trim';
import { iconClass } from './icons';

export default [
	{ 'name': 'capitalize', 'action': capitalize },
	{ 'name': 'lowercase', 'action': lowercase },
	{ 'name': 'uppercase', 'action': uppercase },
	{ 'name': 'trim', 'action': trim },
	{ 'name': 'iconClass', 'action': iconClass }
];
